import requestTypes from 'constants/requestTypes'
import { fetchNext, getSSOToken, getToken, requestForgotPassword } from 'utils/request'
import { LoginData, TokenResponse, LogoutResponse, validateUserResponse } from 'constants/types'
import { getApiWorkspaceUrl } from 'utils/endpoints'

export default class AccountApi {
  static obtainToken = (credentials: LoginData): Promise<TokenResponse> => getToken(`/auth/login`, credentials)

  static validateUser = (): Promise<{ data: validateUserResponse }> => fetchNext(requestTypes.GET, '/session/validate')

  static accessToken = (token: string): Promise<{ data: TokenResponse }> => getSSOToken('/token', token)

  static logoutUser = (
    expired: boolean
  ): Promise<{
    data: LogoutResponse
    metadata: { statuscode: number }
  }> => fetchNext(requestTypes.POST, '/auth/logout', { expired })

  static forgotPassword = (
    email: string
  ): Promise<{
    data: string
    metadata: { statuscode: number }
  }> =>
    requestForgotPassword(`${getApiWorkspaceUrl() || ''}/auth/users/forgot/password`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    })

  static validateTokenForgotPassword = (
    token: string
  ): Promise<{
    data: string
    metadata: { statuscode: number }
  }> =>
    requestForgotPassword(`${getApiWorkspaceUrl() || ''}/reset/password/token/validate`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${'Bearer '}${token || ''}`,
        Accept: `application/json;`
      }
    })

  static updatePassword = (
    password: string,
    token: string
  ): Promise<{
    data: string
    metadata: { statuscode: number }
  }> =>
    requestForgotPassword(`${getApiWorkspaceUrl() || ''}/auth/users/reset/password`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${'Bearer '}${token || ''}`,
        Accept: `application/json;`
      },
      body: JSON.stringify({ password })
    })
}
